import { createReducer, on } from '@ngrx/store';

import { IResidentFeedbackEligibility } from '../../models';
import { ActionStateCreator, IActionState } from '../../utils';
import * as fromActions from './resident-feedback.actions';

export interface IResidentFeedbackState {
  eligibility: IResidentFeedbackEligibility | null;
  eligibilityActionState: IActionState;
  saveFeedbackActionState: IActionState;
  promptShownThisSession: boolean;
}

export const initialState: IResidentFeedbackState = {
  eligibility: null,
  eligibilityActionState: ActionStateCreator.create(),
  saveFeedbackActionState: ActionStateCreator.create(),
  promptShownThisSession: false,
};

// `promptShownThisSession` needs no LOGOUT handler: the clearState meta-reducer
// resets every slice except `appSettings`, so it returns to `false` on logout.
export const residentFeedbackReducer = createReducer(
  initialState,

  on(fromActions.LoadResidentFeedbackEligibility, state => ({
    ...state,
    eligibilityActionState: ActionStateCreator.onStart(),
  })),

  on(fromActions.LoadResidentFeedbackEligibilitySuccess, (state, { eligibility }) => ({
    ...state,
    eligibility,
    eligibilityActionState: ActionStateCreator.onSuccess(),
  })),

  // Fail closed: `eligibility` stays null, so the gate stays shut (ART-19551 spec ED-2).
  on(fromActions.LoadResidentFeedbackEligibilityFailed, (state, { error }) => ({
    ...state,
    eligibilityActionState: ActionStateCreator.onError(error),
  })),

  on(fromActions.SaveResidentFeedback, state => ({
    ...state,
    saveFeedbackActionState: ActionStateCreator.onStart(),
  })),

  on(fromActions.SaveResidentFeedbackSuccess, state => ({
    ...state,
    saveFeedbackActionState: ActionStateCreator.onSuccess(),
  })),

  on(fromActions.SaveResidentFeedbackFailed, (state, { error }) => ({
    ...state,
    saveFeedbackActionState: ActionStateCreator.onError(error),
  })),

  on(fromActions.MarkResidentFeedbackPromptShown, state => ({
    ...state,
    promptShownThisSession: true,
  }))
);

export const getEligibility = (state: IResidentFeedbackState) => state.eligibility;
export const getPromptShownThisSession = (state: IResidentFeedbackState) =>
  state.promptShownThisSession;
export const getSaveFeedbackActionState = (state: IResidentFeedbackState) =>
  state.saveFeedbackActionState;
